import { API } from '@/api';
import axios from 'axios';

const state = {
};
const getters = {
};
const actions = {
  getUnidadesList({ commit, State }, {datos, options}) {
    console.log('Admin: %o Condo: %o', datos.admin, datos.condo);
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    return API.get(`${datos.admin.id}/${datos.condo.id}/unidades/list/`, {params: queryString})
      .then((response) => response.data);
  },
  getUnidadesListMax({ commit, State }, {datos}) {
    const queryString = {page: 0, size: 500};
    return API.get(`${datos.admin.id}/${datos.condo.id}/unidades/list/`, {params: queryString})
      .then((response) => response.data);
  },

  getUnidadesPropList({ commit, State }, {datos, options}) {
    console.debug('Admin: %o Condo: %o', datos.admin, datos.condo);
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    return API.get(`${datos.admin.id}/${datos.condo.id}/unidades/prop/`, {params: queryString})
      .then((response) => response.data )
      .then((response) => {response.content.forEach((unidad, idx) => {
        unidad.saldo = 0;
        unidad.saldoF = 0;
      });
                           return response; });
  },
  getUnidadesPropListMax({ commit, State }, {datos}) {
    const queryString = {page: 0, size: 500};
    return API.get(`${datos.admin.id}/${datos.condo.id}/unidades/prop/`, {params: queryString})
      .then((response) => response.data);
  },
  async addUnidad({ commit, State }, datos) {
    console.debug('Admin: %o Condo: %o', datos.admin, datos.condo);
    const response = await API.post(`${datos.admin.id}/${datos.condo.id}/unidades/add/`, datos.condoUnidad);
    return response;
  },
  async deleteUnidad({ commit, State }, datos) {
    console.debug('Admin: %o Condo: %o', datos.admin, datos.condo);
    const response = await API.delete(`${datos.admin.id}/${datos.condo.id}/unidades/delete/${datos.unidad.id}`);
    return response;
  },
  async updateUnidad({ commit, State }, datos) {
    // console.log('unidadesTS: ', datos)
    const response = await API.post(`${datos.admin.id}/${datos.condo.id}/unidades/update`, datos.unidad);
    return response;
  },
  async getFree({ commit, State }, datos) {
    const response = await API.get(`${datos.admin.id}/${datos.condo.id}/unidades/free/`);
    return response;
  },
  async getFreeMax({ commit, State }, datos) {
    const queryString = {page: 0, size: 500};
    const response = await API.get(`${datos.admin.id}/${datos.condo.id}/unidades/free/`, {params: queryString});
    return response;
  },
  async getUnidadById({ commit, State }, {admin, condo, unidad}) {
    const response = await API.get(`${admin.id}/${condo.id}/unidades/get/${unidad.id}`);
    return response;
  },
  getUnidadSaldo({commit, State}, {admin, condo, unidad, x}) {
    return API.get(`${admin.id}/${condo.id}/unidades/get/${unidad.id}/saldo/${x}`)
    .then((response) => response.data);
  },
  getUnidadSaldoRecibo({commit, State}, {admin, condo, requ}) {
    return API.post(`${admin.id}/${condo.id}/unidades/get/${requ.unidadId}/saldo`, requ)
    .then((response) => response.data);
  },
  getEstadoCta({commit, State}, {admin, condo, unidad, req}) {
    const response = API.post(`${admin.id}/${condo.id}/unidades/get/${unidad.id}/edoCta`, req);
    return response;
  },
  getEstadoCta2({commit, State}, {admin, condo, unidad, req}) {
    const response = API.post(`${admin.id}/${condo.id}/unidades/get/${unidad.id}/edoCta2`, req);
    return response;
  },
};
const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
